import { Box, Group, GroupProps, Progress, Title } from '@mantine/core';
import React from 'react';

const Progressbar = ({
  title = null,
  progress = null,
  children = null,
  align = 'center',
  preChildren = null,
  preContainerProps = null,
  ...rest
}: React.PropsWithChildren<{
  title: string | React.ReactNode;
  progress?: React.ComponentProps<typeof Progress>;
  align: GroupProps['position'];
  preChildren?: React.ReactNode;
  preContainerProps?: GroupProps;
}>) => (
  <Box {...rest}>
    <Group position={align} {...preContainerProps}>
      {preChildren}
      <Title order={2} size="h3" py="12px" weight="normal">
        {title}
      </Title>
      {children}
    </Group>
    <Progress {...progress} />
  </Box>
);

export default Progressbar;
